import { Box, Flex, Text } from '@chakra-ui/react'
import { HeaderCard } from './components/HeaderCard'
import { Card } from './components/Card'
import { Button } from './components/Button'
import { GiReceiveMoney } from 'react-icons/gi'
import { user } from '../../helpers/user'

import { Link } from 'react-router-dom'
import { Ranking } from './Ranking'
import { VendasPedido } from './VendasPedido'
import { NovosChamados } from './NovosChamados'
import { Pendencias } from './Pendencias'
import { Propostas } from './Propostas'
import { MeusPedidos } from './MeusPedidos'
import { ClientesImportantes } from './ClientesImportantes'
import { SelectVendedores } from './components/SelectVendedores'
import { useQuery } from 'react-query'
import { DadosUsuarioHome } from '../../services/api'
import { formatPrice } from '../../utils/formatPrice'
import { useState } from 'react'
import { RetornarEm } from './components/RetornarEm'

async function getUserData(cod) {
  const { data } = await DadosUsuarioHome.get(`/${cod}`)

  data.vendas_mes = formatPrice(data.vendas_mes)
  data.vendas_semana = formatPrice(data.vendas_semana)

  data.ranking_pedido_proximo = parseInt(data.ranking_pedidos_mes) === 10 ? 10 : parseInt(data.ranking_pedidos_mes) + 1

  data.pedido_proximo = data.valor_pedidos_mes - data.valor_pedido_baixo <= 0 ? 1 : data.valor_pedidos_mes - data.valor_pedido_baixo

  data.ranking_vendas_mes = parseInt(data.ranking_vendas_mes) === 0 ? 1 : data.ranking_vendas_mes

  data.ranking_pedidos_mes = parseInt(data.ranking_pedidos_mes) === 0 ? 1 : data.ranking_pedidos_mes

  data.ranking_valor_proximo = parseInt(data.ranking_vendas_mes) === 10 ? 10 : parseInt(data.ranking_vendas_mes) + 1

  data.valor_a_alcancar = parseFloat(data.valor_venda_cima) - parseFloat(data.valor_vendas_mes)

  data.valor_proximo = parseFloat(data.valor_vendas_mes) - parseFloat(data.valor_venda_baixo)

  data.ranking_valor_a_alcancar = parseInt(data.ranking_vendas_mes) === 1 ? 1 : Math.abs(parseInt(data.ranking_vendas_mes) - 1)

  data.ranking_pedido_a_alcancar = parseInt(data.ranking_pedidos_mes) === 1 ? 1 : parseInt(data.ranking_pedidos_mes) - 1

  data.pedido_a_alcancar = data.valor_pedido_cima - data.valor_pedidos_mes <= 0 ? 1 : data.valor_pedido_cima - data.valor_pedidos_mes

  data.lastPositionPedidos = parseInt(data?.ranking_pedidos_mes) === parseInt(data?.posicao_ultimo_colocado)

  data.total_pedidos_vendedor = parseInt(data.aprovacoes) + parseInt(data.pedidos_producao) + parseInt(data.pedidos_expedicao)

  return data
}

export function NewHome() {
  const [codCustomerSelected, setCodCustomerSelected] = useState(user?.codigo_usuario !== 30 ? user?.codigo_usuario : 0)

  const { data: infoCustomer, isLoading } = useQuery({
    queryKey: ['users-customers-selected', codCustomerSelected],
    queryFn: () => getUserData(codCustomerSelected),
    refetchOnWindowFocus: true,
  })

  return (
    <>
      <Box
        mt={2}
        py={'24px'}
        bgColor="#F5F5F5"
        color="#2D2D2D"
        fontWeight="semibold"
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="100%"
        position="relative"
        fontFamily={'Open Sans, sans-serif'}
      >
        <Box maxW="1300px" w="full" position="relative">
          <Flex gap={4} alignItems="center" maxW="500px" w="100%" position="absolute" top="50%" left="10" transform="translateY(-50%)">
            <Button
              w="100%"
              color="#FFA200"
              borderColor="#FFA200"
              iconColor="#FFA200"
              as={Link}
              to={`/dashboard-produtividade-detalhada?v=${codCustomerSelected}`}
            >
              Dashboard Detalhado
            </Button>
            <Button
              w="100%"
              color="#FFA200"
              borderColor="#FFA200"
              iconColor="#FFA200"
              as={Link}
              to={`/produtividade-detalhada?v=${codCustomerSelected}`}
            >
              Dashboard
            </Button>
          </Flex>
          <Text textAlign="center">RESUMO DE ATIVIDADES</Text>
          <SelectVendedores setCodCustomerSelected={setCodCustomerSelected} codCustomerSelected={codCustomerSelected} />
        </Box>
      </Box>

      <Box minH="100vh" w="100%" bgColor="#FBFBFB" py={4}>
        <Box maxW="1345px" mx="auto" px="20px" display="flex" w="100%" gap={2} flexWrap="wrap">
          <Flex flexDir="column" gap={2}>
            {/* NOVOS CHAMADOS */}
            <NovosChamados infoCustomer={infoCustomer} codCustomerSelected={codCustomerSelected} isLoading={isLoading} />

            {/* PENDENCIAS */}
            <Pendencias infoCustomer={infoCustomer} codCustomerSelected={codCustomerSelected} isLoading={isLoading} />
          </Flex>
          {/* PROPOSTAS */}
          <Propostas infoCustomer={infoCustomer} codCustomerSelected={codCustomerSelected} isLoading={isLoading} />
          <Box w="782px">
            <HeaderCard title="Minhas Vendas" icon={<GiReceiveMoney size={24} color="#2D2D2D" />} />

            <Card py={'16px'} mt={2} px={'40px'} display="flex" alignItems="center" justifyContent="space-between" isLoading={isLoading}>
              <VendasPedido infoCustomer={infoCustomer} codCustomerSelected={codCustomerSelected} />
            </Card>
            <Card mt={2} px={2} py={1} isLoading={isLoading}>
              <Ranking infoCustomer={infoCustomer} />
            </Card>
          </Box>

          <Box w="513px">
            <MeusPedidos isLoading={isLoading} infoCustomer={infoCustomer} codCustomerSelected={codCustomerSelected} />

            <ClientesImportantes isLoading={isLoading} infoCustomer={infoCustomer} codCustomerSelected={codCustomerSelected} />
          </Box>
        </Box>
      </Box>
      <RetornarEm selectedUser={codCustomerSelected} />
    </>
  )
}
